import { Directive, Output, EventEmitter, HostListener, Input } from '@angular/core';
import 'mdn-polyfills/Element.prototype.closest';

@Directive({
    selector: '[agprClickUnless]',
    standalone: false
})
export class ClickUnlessDirective {
    /* eslint-disable @angular-eslint/no-input-rename */
    @Input('agprClickUnlessSelectors') excludedSelectors: string[] = null;
    @Input('agprClickUnlessTargets') excludedTargets: HTMLElement[] = null;

    @Output('agprClickUnless') clickUnless: EventEmitter<Event> = new EventEmitter<Event>();

    @HostListener('click', ['$event'])
    clickEvent(event): void {
        const target: HTMLElement = event.target;
        const isExcludedBySelector: boolean = this.isExcludedBySelector(target);
        const isExcludedByTarget: boolean = this.isExcludedByTarget(target);
        const allowClick: boolean = !isExcludedBySelector && !isExcludedByTarget;

        if (allowClick) {
            this.clickUnless.emit(event);
        }
    }

    /**
    * Gets the state of whether or not the target has excluded selectors
    */
    private isExcludedBySelector(target: HTMLElement): boolean {
        const hasExcludedSelectorList: boolean = Array.isArray(this.excludedSelectors);
        let isExcludedBySelector: boolean = false;

        if (hasExcludedSelectorList) {
            this.excludedSelectors.forEach(selector => {
                const hasCurrentSelector: boolean = target.closest(selector) !== null;

                if (hasCurrentSelector) {
                    isExcludedBySelector = true;
                }
            });
        }

        return isExcludedBySelector;
    }

    /**
    * Gets the state of whether or not the target is in the list of excluded targets
    */
    private isExcludedByTarget(target: HTMLElement): boolean {
        const hasExcludedTargetList: boolean = Array.isArray(this.excludedTargets);
        let isExcludedByTarget: boolean = false;

        if (hasExcludedTargetList) {
            this.excludedTargets.forEach(excludedTarget => {
                const hasExcludedParent: boolean = excludedTarget.contains(target);
                const isExcluded: boolean = excludedTarget === target;

                if (isExcluded || hasExcludedParent) {
                    isExcludedByTarget = true;
                }
            });
        }

        return isExcludedByTarget;
    }
}
